import { Component, OnInit, ViewEncapsulation, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Helpers } from '../../../helpers';
import { DataService } from '../../../_services/data.service';
import '../../../../assets/snippets/superset/js/superset/filtersform.js';

declare let mLayout: any;
declare let $: any;
declare let FiltersForm: any;

@Component({
    standalone: false,
    selector: "app-right-filter-menu",
    templateUrl: "./right-filter-menu.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class RightFilterMenuComponent implements OnInit, AfterViewInit {
    @Output() openmenu: EventEmitter<any> = new EventEmitter<any>();
    @Output() filtering: EventEmitter<any> = new EventEmitter<any>();

    constructor(private _dataService: DataService) {
    }

    ngOnInit() {
        $('#heatmap_div_search').hide();
        $('#heatmap_div_search').removeClass('enable-search');

        var filterFormToInit = true;

        if (localStorage.getItem("tz") === null || localStorage.getItem("tz") === undefined) {
            this._dataService.get_time_zones();
            if (filterFormToInit) {
                FiltersForm.init();
            }
        }

        if (localStorage.getItem("locs") === null || localStorage.getItem("locs") === undefined) {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            this._dataService.get_locations(currentUser.consumer_name, currentUser.token, currentUser.credential_username) // Get locations list
                .subscribe(data => {
                    if (filterFormToInit) {
                        FiltersForm.init();
                        filterFormToInit = false;
                    }
                });
        }
        if (localStorage.getItem("locGroups") === null || localStorage.getItem("locGroups") === undefined) {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            this._dataService.get_location_groups(currentUser.consumer_name, currentUser.token, currentUser.credential_username) // Get locations list
                .subscribe(data => {
                    if (filterFormToInit) {
                        FiltersForm.init();
                        filterFormToInit = false;
                    }
                });
        }
        if (filterFormToInit) {
            FiltersForm.init();
        }
    }

    closeRightMenu() {
        FiltersForm.closeRightMenu();
    }

    searching() {
        let tmp = JSON.parse(localStorage.getItem('dashboard'));
        let dashboard = (tmp) ? tmp : null;
        if (dashboard) this.filtering.emit(FiltersForm.search(dashboard));
    }

    openRightMenu() {
        this.openmenu.emit(FiltersForm.openRightMenu());
    }

    ngAfterViewInit() {

    }

}
